<template>
  <div id="app" class="navbar-top" v-if="isAuth">
    <navbar></navbar>
    <div class="page-content">
      <sidebar></sidebar>
      <router-view />
    </div>
    <online-user></online-user>
    <ExportCard
      v-if="isShowExportHistory && exportHistoryFilter.length > 0"
      @closeExportCard="onCloseExportHistory"
      :exportData="exportHistoryFilter"
      @reload="loadExportHistory"
    ></ExportCard>
  </div>
  <div id="app" :class="{ 'navbar-top': isRegisterPage }" v-else>
    <navbar-frontend v-if="isRegisterPage"></navbar-frontend>
    <div class="page-content">
      <div class="content-wrapper">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './views/layout/Navbar'
import NavbarFrontend from './views/layout/NavbarFrontend'
import Sidebar from './views/layout/Sidebar'
import OnlineUser from './components/OnlineUser'
import { mapGetters, mapActions } from 'vuex'
import ExportCard from './components/ExportCard.vue'
import moment from 'moment'
export default {
  components: {
    Navbar,
    Sidebar,
    OnlineUser,
    NavbarFrontend,
    ExportCard
  },
  data() {
    return {
      pollingHistory: null
    }
  },
  created() {
    if (this.isAdmin) {
      this.loadExportHistory()
      this.pollingHistory = setInterval(() => {
        this.loadExportHistory()
      }, 30000)
    }
  },
  destroyed() {
    clearInterval(this.pollingHistory)
  },
  computed: {
    ...mapGetters({
      isAuth: 'isAuth',
      isAdmin: 'isAdmin',
      exportHistory: 'exportHistoryData',
      isShowExportHistory: 'isShowExportHistory'
    }),
    isRegisterPage() {
      return this.$route.name === 'register'
    },
    exportHistoryFilter() {
      return this.exportHistory.filter(
        (history) =>
          history.isVisible &&
          moment(history.createdAt).isAfter(moment().subtract(1, 'days'))
      )
    }
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    online: function (users) {
      this.setOnlineUsers(users)
    },
    broadcast: function (text) {
      this.$swal({
        toast: true,
        position: 'top',
        icon: 'info',
        title: text,
        timer: 0,
        showConfirmButton: false,
        showCloseButton: true
      })
    },
    disconnect: function () {
      let interval = setInterval(() => {
        if (!this.$socket.connected) {
          this.$socket.connect()
          clearInterval(interval)
        }
      }, 1500)
    },
    getUserTagging: function (users) {
      this.setUserTagging(users)
    }
  },

  methods: {
    ...mapActions({
      setOnlineUsers: 'setOnlineUsers',
      setUserTagging: 'setUserTagging',
      loadExportHistory: 'loadExportHistory',
      showExportHistory: 'showExportHistory',
      clearExportHistory: 'clearExportHistory'
    }),
    onCloseExportHistory() {
      this.showExportHistory(false)
      this.clearExportHistory({
        ids: this.exportHistoryFilter.map((v) => v._id),
        data: { isVisible: false }
      })
    }
  }
}
</script>

<style scoped>
#app {
  height: 100vh;
  display: flex;
}
</style>
